import { Section } from 'foundations-components/transitional/components/Section';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H1 } from 'foundations-components/transitional/components/H1';
import { View } from 'foundations-components/components/View';
import ProfessorList from '../LessonPage/ProfessorList';
import UsageTracker from '../../utils/UsageTracker';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getHumanizedDuration } from '../../utils/utils';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import uniqBy from 'hs-lodash/uniqBy';
import { isPracticalExerciseAsset, isQuizAsset, isVideoAsset } from '../../features/tracks/tracksUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePaddedUISection = ({
  children
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Section, {
    paddingInline: isTablet ? '300' : '400',
    children: children
  });
};
const TrackIntroductionInformation = ({
  track
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const videoLength = getHumanizedDuration(track.duration);
  const trackContent = track.lessons.map(lesson => lesson.content).flat();
  const numQuizzes = trackContent.filter(asset => isQuizAsset(asset)).length;
  const numPracticalExercises = trackContent.filter(asset => isPracticalExerciseAsset(asset)).length;
  const trackProfessors = uniqBy(trackContent.flatMap(asset => isVideoAsset(asset) ? asset.professors : []).filter(p => p != null), 'id');
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'COURSE',
      appearsIn: 'courses',
      organisation,
      organisationUrl,
      professorId,
      trackId: track.id
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "900",
    children: [/*#__PURE__*/_jsx(MobilePaddedUISection, {
      children: /*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.aboutThisTrack"
        })
      })
    }), /*#__PURE__*/_jsx(MobilePaddedUISection, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "baseline",
        direction: "row",
        gap: 16,
        justify: "start",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-intro-lesson-count",
            message: "learningCenter.tracks.lessons",
            options: {
              numLessons: track.lessons.length
            }
          })
        }), /*#__PURE__*/_jsx(View, {
          borderInlineStartColor: "border-core-default",
          borderInlineStartStyle: "solid",
          borderInlineStartWidth: "100",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-intro-track-duration",
            message: "learningCenter.tracks.totalVideoLengthDuration",
            options: {
              videoLength
            }
          })
        }), !!numQuizzes && /*#__PURE__*/_jsx(View, {
          borderInlineStartColor: "border-core-default",
          borderInlineStartStyle: "solid",
          borderInlineStartWidth: "100",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.tracks.quizzes",
            options: {
              numQuizzes
            }
          })
        }), !!numPracticalExercises && /*#__PURE__*/_jsx(View, {
          borderInlineStartColor: "border-core-default",
          borderInlineStartStyle: "solid",
          borderInlineStartWidth: "100",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.tracks.practicalExercises",
            options: {
              numPracticalExercises
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsx(MobilePaddedUISection, {
      children: track.description
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(View, {
        paddingInline: isMobile ? '200' : '400',
        children: /*#__PURE__*/_jsx(ProfessorList, {
          handleOrganisationUrlClick: handleOrganisationUrlClick,
          i18nHeading: "learningCenter.tracks.trackProfessors",
          isAccordion: isMobile,
          professors: trackProfessors
        })
      })
    })]
  });
};
export default TrackIntroductionInformation;